<template>
    <div v-for="manufacturer in parts" :key="manufacturer.manufacturer">
        <div class="products-view__list products-list products-list--grid--4" data-layout="table" data-with-features="false">
            <div class="products-list__vendor-head">{{ manufacturer.description }}</div>
            <div class="products-list__vendor-subhead">{{ getFirstItemDescription(manufacturer.parts) }}</div>
            <div class="products-list__head" v-if="manufacturer.parts.length > 0">
                <div class="products-list__column products-list__column--image">Image</div>
                <div class="products-list__column products-list__column--qty">QTY</div>	
                <div class="products-list__column products-list__column--product">Product</div>
                <div class="products-list__column products-list__column--rating products-list__column--information">Information</div>
                <div class="products-list__column products-list__column--rating products-list__column--availability">Availability</div>
                <div class="products-list__column products-list__column--price">Price</div>
            </div>
            <div class="products-list__content" v-if="manufacturer.parts.length > 0">
                <results-product-item 
                    v-for="(product, indx) in manufacturer.parts"
                    :key="product.ID"
                    :index='indx'
                    :product="product"
                    :source-page="'InterchangeSearch'">
                </results-product-item>
            </div>
            <div class="text-center pt-2 pb-2" v-if="manufacturer.parts.length === 0">
                <strong>No parts found.</strong>
            </div>

        </div>
        <div class="block-space block-space--layout--divider-sm"></div>
    </div>

</template>

<script>
import ResultsProductItem from '../searchresults/ResultsProductItem.vue';

export default {
    components : {
        ResultsProductItem
    },
    props: {
        parts: {
            type: Array,
            required: true
        }
    },
    methods: {
        getFirstItemDescription(arr) {
            for (let x in arr) {
                if (arr[x].description) {
                    return arr[x].description;
                }
            }
            return '';
        }
    }
}
</script>